import { render, staticRenderFns } from "./mobileValidate.vue?vue&type=template&id=645d4d04&"
import script from "./mobileValidate.vue?vue&type=script&lang=ts&"
export * from "./mobileValidate.vue?vue&type=script&lang=ts&"
import style0 from "./mobileValidate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports